module.exports = __webpack_public_path__ + "static/media/chevron-right.3bcfb0db.svg";